import React, { useCallback, useRef } from 'react';

interface ClickableNodeProps extends React.HTMLAttributes<HTMLDivElement> {
  onSingleClick: () => void;
  onDoubleClick: () => void;
  clickDelay?: number;
}

export const ClickableNode = (props: ClickableNodeProps) => {
  const { onSingleClick, onDoubleClick, clickDelay = 200, children, ...rest } = props;
  const clickTimeout = useRef(null);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (!onSingleClick) {
        return;
      }
      if (e.detail > 1 && onDoubleClick) {
        handleDoubleClick(e);
        return;
      }
      clickTimeout.current = window.setTimeout(() => {
        onSingleClick();
      }, clickDelay);
    },
    [onSingleClick, clickDelay],
  );

  const handleDoubleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (clickTimeout.current) {
        clearTimeout(clickTimeout.current);
        clickTimeout.current = null;
      }
      onDoubleClick?.();
    },
    [onDoubleClick],
  );

  return (
    <div onClick={handleClick} onDoubleClick={handleDoubleClick} {...rest}>
      {children}
    </div>
  );
};
